import React, { useState } from 'react';
import { Field as Fieldmik, FieldArray, ErrorMessage } from 'formik';
import { Form as FormUi, Input, Button, Dropdown, Grid, Header, Table, Icon } from 'semantic-ui-react';
import { MyInput, MyNormalInput } from '../../../formikInput/input';
import ProductSKUDropdown from './productSKUDropdown';

const AddProduct = ({ handleChange, billmode, masterState, vendorStateId, gstNotApplicableReason, isGstApplicable }) => {

  const [productData, setProductData] = useState([])
  const [isUpdated, setisUpdated] = useState(false);

  const getProductData = childData => {
    setProductData(childData);
  }

  const valueChangeDiscount = (object) => {
    setisUpdated(object.discountType);
    let tempAmount = '';
    if (object.discount > 0 && object.discountType == 1) {
      let finalRate = +object.rate * +object.quantity
      tempAmount = +finalRate - +object.discount
    } else {
      let finalRate = +object.rate * +object.quantity
      tempAmount = +finalRate - (+finalRate * +object.discount / 100)
    }
    object.iGst = isGstApplicable ? +object.iGstPercent / 100 * +tempAmount : 0;
    object.cGst = isGstApplicable ? +object.cGstPercent / 100 * +tempAmount : 0;
    object.sGst = isGstApplicable ? +object.sGstPercent / 100 * +tempAmount : 0;

    object.taxableAmount = +tempAmount

    return object.amount = +tempAmount + +object.iGst + +object.cGst + +object.sGst
  };

  return (
    <div className="ui form tiny">
      <FieldArray
        key={isUpdated}
        name="productDetails">
        {({ push, remove, replace, form }) => {

          const { inititalValues, values, setFieldValue } = form
          const { productDetails } = values

          let productSelectedArray = []

          productDetails.map((product, index) => {
            let temp = {}
            temp.productName = product.productName

            productSelectedArray[index] = temp
          })
          let finalAMT = 0
          values.productDetails.map(({ amount }) => finalAMT += amount)
          values.finalAmount = finalAMT
          const handleUpdateProduct = (e, data, index, object) => {

            const { setFieldValue } = form

            let addedProductObject = productData.filter(e => {
              if (data != undefined) {
                return e.psId === data.value
              }
            })

            if (addedProductObject.length) {
              setFieldValue(data.name, data.value).then(() => {
                replace(index, {
                  productName: data.value,
                  productCode: addedProductObject && addedProductObject[0] && addedProductObject[0].psCode || "",
                  hsnCode: addedProductObject && addedProductObject[0] && addedProductObject[0].HSNCode || "",
                  sacCode: addedProductObject && addedProductObject[0] && addedProductObject[0].SACCode || "",
                  quantity: object.quantity,
                  discountType: object.discountType,
                  discount: addedProductObject && addedProductObject[0] && addedProductObject[0].discount || 0,
                  tdsId: addedProductObject && addedProductObject[0] && addedProductObject[0].tdsTaxSectionId || "",
                  tdsTaxCode: addedProductObject && addedProductObject[0] && addedProductObject[0].tdsTaxCode || "",
                  rate: addedProductObject && addedProductObject[0] && addedProductObject[0].sellingPrice || 0,
                  iGstPercent: vendorStateId === masterState ? "" : addedProductObject && addedProductObject[0] && addedProductObject[0].gstPercentage,
                  cGstPercent: vendorStateId === masterState ? addedProductObject && addedProductObject[0] && addedProductObject[0].gstPercentage / 2 : "",
                  sGstPercent: vendorStateId === masterState ? addedProductObject && addedProductObject[0] && addedProductObject[0].gstPercentage / 2 : "",
                  remarks:object.remarks,
                  addRemarks:true,
                  isEditable: object.isEditable ? object.isEditable : false
                })
              })
            }
          }

          return (
            <>
              <Table unstackable size="large" key={isUpdated} compact="very" className="w3-small">
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell className="w3-white" colSpan="10">  <label className="labelName w3-text-blue" style={{ display: "flex" }}>Product/Service Details  </label>
                    </Table.HeaderCell>
                    <Table.HeaderCell colSpan="8">
                      {
                        gstNotApplicableReason ?
                          <h2 style={{ fontSize: '12px', color: '#1678c2' }} className='mt-2'>Reason:  {gstNotApplicableReason}</h2>
                          : null
                      }
                    </Table.HeaderCell>
                  </Table.Row>
                  <Table.Row >
                    <Table.HeaderCell className="labelName p-bold-600">Product Details</Table.HeaderCell>
                    <Table.HeaderCell className="labelName p-bold-600">HSN/SAC Code</Table.HeaderCell>
                    <Table.HeaderCell className="labelName p-bold-600">Quantity</Table.HeaderCell>
                    <Table.HeaderCell className="labelName p-bold-600">Rate</Table.HeaderCell>
                    <Table.HeaderCell className="labelName p-bold-600">Discount</Table.HeaderCell>
                    <Table.HeaderCell className="labelName p-bold-600">IGST%</Table.HeaderCell>
                    <Table.HeaderCell className="labelName p-bold-600">IGST(₹)</Table.HeaderCell>
                    <Table.HeaderCell className="labelName p-bold-600">CGST</Table.HeaderCell>
                    <Table.HeaderCell className="labelName p-bold-600">CGST(₹)</Table.HeaderCell>
                    <Table.HeaderCell className="labelName p-bold-600">SGST</Table.HeaderCell>
                    <Table.HeaderCell className="labelName p-bold-600">SGST(₹)</Table.HeaderCell>
                    <Table.HeaderCell className="labelName p-bold-600">Amount</Table.HeaderCell>
                    <Table.HeaderCell className="labelName p-bold-600">Remark</Table.HeaderCell>
                    <Table.HeaderCell textAlign="right" className="labelName p-bold-600">Delete</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  {productDetails.map((object, index) => {

                    const discountOptions = [
                      { key: '1', text: '₹', value: '1' },
                      { key: '2', text: '%', value: '2' },
                    ];


                    let tempAmount = '';
                    if (object.discount > 0 && object.discountType == 1) {
                      let finalRate = +object.rate * +object.quantity
                      tempAmount = +finalRate - +object.discount
                    } else {
                      let finalRate = +object.rate * +object.quantity
                      tempAmount = +finalRate - (+finalRate * +object.discount / 100)
                    }
                    object.iGst = isGstApplicable ? +object.iGstPercent / 100 * +tempAmount : 0;
                    object.cGst = isGstApplicable ? +object.cGstPercent / 100 * +tempAmount : 0;
                    object.sGst = isGstApplicable ? +object.sGstPercent / 100 * +tempAmount : 0;

                    object.taxableAmount = +tempAmount

                    object.amount = +tempAmount + +object.iGst + +object.cGst + +object.sGst

                    return (
                      <Table.Row verticalAlign="middle" key={index} >
                        <React.Fragment>
                          <Table.Cell>
                            <div style={{ display: "flex" }}>
                              <Fieldmik
                                component={ProductSKUDropdown}
                                disabled={object.isEditable ? false : true}
                                handleUpdateProduct={handleUpdateProduct}
                                productIndex={index}
                                productObject={object}
                                getProductData={getProductData}
                                placeholder="Product Name"
                                name={`productDetails[${index}].productName`}
                                style={{ width: '200px' }}
                                value={object.productName ? object.productName : ''}
                                productSelectedArray={productSelectedArray}
                                selectedProductEdit={object.productName}
                              // psCode={'psCode'}
                              />
                            </div>
                            <ErrorMessage name={`productDetails[${index}].productName`}>
                              {error => <strong className="w3-text-red w3-tiny font-weight-bold">{error}</strong>}
                            </ErrorMessage>
                          </Table.Cell>
                          <Table.Cell width={2}>{object.hsnCode || object.sacCode ? `${object.hsnCode, object.sacCode}` : ''}</Table.Cell>
                          <Table.Cell style={{ minWidth: '30px' }}>
                            <Fieldmik
                              component={MyNormalInput}
                              type="number"
                              disabled={object.isEditable ? false : true}
                              value={object.quantity === 0 ? '' : object.quantity}
                              min="1"
                              autoComplete="off"
                              name={`productDetails[${index}].quantity`}
                              size="small"
                              onClick={()=> setFieldValue(`productDetails[${index}].addRemarks`,true)}
                            />
                            <ErrorMessage name={`productDetails[${index}].quantity`}>
                              {error => <strong className="w3-text-red w3-tiny font-weight-bold">{error}</strong>}
                            </ErrorMessage>
                          </Table.Cell>
                          <Table.Cell style={{ minWidth: '100px' }}>
                            <Fieldmik
                              component={MyNormalInput}
                              disabled={object.isEditable ? false : true}
                              type="number"
                              min="0"
                              value={object.rate === 0 ? 0 : object.rate}
                              autoComplete="off"
                              name={`productDetails[${index}].rate`}
                              size="small"
                              onClick={()=> setFieldValue(`productDetails[${index}].addRemarks`,true)}
                            />
                            <ErrorMessage name={`productDetails[${index}].rate`}>
                              {error => <strong className="w3-text-red w3-tiny font-weight-bold">{error}</strong>}
                            </ErrorMessage>
                          </Table.Cell>
                          <Table.Cell style={{ minWidth: '124px' }}>
                            <Fieldmik style={{ width: '60%' }} type="number" component={MyNormalInput} disabled={object.isEditable ? false : true} value={object.discount === 0 ? 0 : object.discount} name={`productDetails[${index}].discount`} size="small"
                              label={<Dropdown placeholder={object.discountType === 2 ? '%' : "₹"} options={discountOptions} defaultValue={object.discountType} disabled={object.isEditable ? false : true}
                                onChange={(value, data) => {
                                  object.discountType = data.value
                                  valueChangeDiscount(object)
                                  setFieldValue(`productDetails[${index}].addRemarks`,true)
                                }} />} labelPosition="right" className="tableinput" />
                          </Table.Cell>
                          <Table.Cell>{object.iGstPercent && isGstApplicable ? `${object.iGstPercent}%` : '0%'}</Table.Cell>
                          <Table.Cell>{object.iGst ? object.iGst.toFixed(2) : '0'}</Table.Cell>
                          <Table.Cell>{object.cGstPercent && isGstApplicable ? `${object.cGstPercent}%` : '0%'}</Table.Cell>
                          <Table.Cell>{object.cGst ? object.cGst.toFixed(2) : '0'}</Table.Cell>
                          <Table.Cell>{object.sGstPercent && isGstApplicable ? `${object.sGstPercent}%` : '0%'}</Table.Cell>
                          <Table.Cell>{object.sGst ? object.sGst.toFixed(2) : '0'}</Table.Cell>
                          <Table.Cell>{object.amount ? object.amount.toFixed(2) : '0'}</Table.Cell>
                          <Table.Cell className= {object.addRemarks == true && !object.remarks ? 'border border-danger' : ''} style={{ minWidth: '100px' }}>
                            <Fieldmik
                              component={MyNormalInput}
                              disabled={object.isEditable ? false : true}
                              type="text"
                              value={object.remarks}
                              autoComplete="off"
                              name={`productDetails[${index}].remarks`}
                              size="small"
                            />
                            <ErrorMessage name={`productDetails[${index}].remarks`}>
                              {error => <strong className="w3-text-red w3-tiny font-weight-bold">{error}</strong>}
                            </ErrorMessage>
                          </Table.Cell>
                          <Table.Cell hidden={(index == 0 || !object.isEditable)? true : false} textAlign="right">
                            <Button onClick={() => remove(index)} type="button" basic size="mini" icon>
                              <Icon className="overhere" color="red" name="trash" />
                            </Button>
                          </Table.Cell>
                        </React.Fragment>

                      </Table.Row>
                    )
                  }
                  )}
                </Table.Body>
              </Table>
              <Grid columns={3}>
                <Grid.Row className="p-2">
                  <Grid.Column width={10}>
                    <Button className="ml-2" type="button" onClick={() => push({isEditable: true, productName: '', startDate: '', endDate: '', hsnCode: '', sacCode: '', quantity: 1, rate: '', discount: '', discountType: '1', iGstPercent: '', iGst: '', cGstPercent: '', cGst: '', sGstPercent: '', sGst: '', amount: '', psCode: '',remarks:'',addRemarks:true })} size="mini" basic color="blue">
                      + Add Product
                    </Button>
                  </Grid.Column>
                  <Grid.Column>
                    {billmode ?
                      <>
                        <Grid.Row>
                          <Header floated="right" as="label" className="labelName p-bold-600" size="tiny">New PO Total</Header>
                          <Header floated="right" as="label" className="labelName" size="tiny">₹ {isNaN(values.manualPoAddedTotal) ? "0.00" : values.manualPoAddedTotal}</Header>
                        </Grid.Row>
                        <Grid.Row>
                          <Header floated="right" as="label" className="labelName p-bold-600" size="tiny">Active PO Total</Header>
                          <Header floated="right" as="label" className="labelName" size="tiny">₹ {values.activePoAddedTotal}</Header>
                        </Grid.Row>
                      </>
                      :
                      ""
                    }
                    <Grid.Row>
                      <Header floated="right" as="label" className="labelName p-bold-600" size="tiny">Total</Header>
                      <Header floated="right" as="label" className="labelName" size="tiny">₹ {values.finalAmount ? values.finalAmount : ''}</Header>
                    </Grid.Row>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </>
          )
        }
        }
      </FieldArray>
    </div>
  )
}

export default AddProduct